import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import TransferLeadsTable from "../../../components/Lead/transferLeads"

const TransferLeads = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Transfer Request Leads | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <TransferLeadsTable />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default TransferLeads
